"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genLabelAndEventName = exports.MESSAGE_BUTTON_EVENT = exports.CLICK_EVENT = exports.FORM_EVENT = exports.FAILED_TO_SUBMIT_EVENT = exports.SUBMIT_EVENT = exports.SENT_EVENT = exports.HIDE_EVENT = exports.SHOW_EVENT = exports.MESSAGE_BUTTON_LABEL = exports.FORM_LABEL = exports.MESSAGE_SUBMIT = exports.MESSAGE_FAILED_TO_SENT = exports.MESSAGE_SENT = exports.WIDGET_CLOSE = exports.WIDGET_OPEN = exports.OPEN_ACTION = void 0;
var WIDGET = 'widget';
var MESSAGE = 'message';
exports.OPEN_ACTION = 'open';
exports.WIDGET_OPEN = WIDGET + ":open"; // widget:open
exports.WIDGET_CLOSE = WIDGET + ":close"; // widget:close
exports.MESSAGE_SENT = MESSAGE + ":sent"; // message:sent
exports.MESSAGE_FAILED_TO_SENT = MESSAGE + ":sent:error"; // message:sent
exports.MESSAGE_SUBMIT = MESSAGE + ":submit";
// label
exports.FORM_LABEL = 'form';
exports.MESSAGE_BUTTON_LABEL = 'messageButton';
// event
exports.SHOW_EVENT = 'show';
exports.HIDE_EVENT = 'hide';
exports.SENT_EVENT = 'sent';
exports.SUBMIT_EVENT = 'submit';
exports.FAILED_TO_SUBMIT_EVENT = 'failedToSubmit';
exports.FORM_EVENT = [exports.SHOW_EVENT, exports.HIDE_EVENT, exports.SENT_EVENT, exports.SUBMIT_EVENT, exports.FAILED_TO_SUBMIT_EVENT];
exports.CLICK_EVENT = 'click';
exports.MESSAGE_BUTTON_EVENT = [exports.CLICK_EVENT];
var genLabelAndEventName = function (label, event) { return label + ":" + event; };
exports.genLabelAndEventName = genLabelAndEventName;
